import React, { useCallback, useState } from 'react';
import { Alert, AlertIcon } from '@chakra-ui/react';
// import { ImTicket } from 'react-icons/im';
import { IoTicketOutline } from 'react-icons/io5';

import api from '../../../services/api';
import Button from '../../Button';

import { Container, Content, Header, ContentView, ButtonsView } from './styles';

interface ModalPARAMS {
  id?: string;
  onClose: any;
  isVisible: boolean;
  cupom: CupomDATA;
  setCupons: any;
  setLoadingList: any;
}
interface CupomDATA {
  cat: number;
  cod_cupom: string;
  cod_desc: string;
  cupom: string;
  dat_cadastro: string;
  formapg: string;
  id_cliente: string;
  id_desconto: string;
  nome: string;
  orig: string;
  prim: string;
  primeira_comp: string;
  selec_est: string;
  tip: string;
  val: number;
  val_min: number;
  validade: string;
  valor: string;
  vencimento: string;
  vlr_minimo: string;
  venda_perc: number;
  venda_qtd: number;
  venda_tkm: number;
  venda_vlr: number;
}

const ModalCupomRemove: React.FC<ModalPARAMS> = ({
  onClose = () => {},
  isVisible,
  cupom,
  setCupons,
  setLoadingList,
}) => {
  const handleOnClose = useCallback(() => {
    setVisible(false);
    setTimeout(() => {
      onClose();
    }, 300);
  }, [onClose]);

  const handleRemoveCupom = useCallback(async () => {
    setLoadingList(true);
    await api
      .delete(`portal/cupom/remove/${cupom.id_desconto}`)
      .then(response => {
        if (response.data.check.che === 'N') {
          setMessage(response.data.check.men);
          setMessageVisible(true);
          return;
        }

        setCupons(response.data.cupons);
        handleOnClose();
      })
      .finally(() => {
        setLoadingList(false);
      });
  }, [cupom, setCupons, setLoadingList, handleOnClose]);

  const [visible, setVisible] = useState(isVisible);
  const [messageVisible, setMessageVisible] = useState(false);
  const [message, setMessage] = useState('');

  return (
    <Container id="modalCupomRemove">
      <Content className={`${visible ? 'active' : ''}`}>
        <Header>
          <h1>Exclusão do cupom de desconto.</h1>

          <div className="cupom">
            <div className="cupom-title">
              <div>
                <IoTicketOutline />

                <span>{cupom.valor}</span>
              </div>
            </div>

            <div className="cupom-dates">
              <div className="inicio">
                <span className="label">Criado em</span>
                <span>{cupom.dat_cadastro}</span>
              </div>

              <div className="fim">
                <span className="label">Válido até</span>
                <span>{cupom.validade}</span>
              </div>
            </div>
          </div>
        </Header>

        <ContentView>
          {messageVisible && (
            <Alert
              status="error"
              style={{
                marginTop: '10px',
                marginBottom: '10px',
                borderRadius: '10px',
              }}
            >
              <AlertIcon />
              {message}
            </Alert>
          )}

          <h2>Deseja excluir este cupom?</h2>
        </ContentView>

        <ButtonsView>
          <Button
            onClick={handleOnClose}
            type="button"
            style={{
              backgroundColor: '#fff',
              border: '2px solid #1a83ff',
              color: '#1a83ff',
              fontSize: '18px',
            }}
          >
            Cancelar
          </Button>
          <Button
            onClick={() => handleRemoveCupom()}
            type="submit"
            style={{
              paddingRight: '50px',
              paddingLeft: '50px',
              fontSize: '18px',
            }}
          >
            Excluir
          </Button>
        </ButtonsView>
      </Content>
    </Container>
  );
};

export default ModalCupomRemove;
